import ItemView, {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import Icon from 'components/Icon';
import { item_createNewSearchTag } from 'store/providers/providerSlice';
import { getLangFromLocalStorage } from '../../../../utils/LanguageLocalStorage';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';
import { orange } from '../../../../utils/style/colors';
import i18n from '../../../../i18n';
import { IUsers } from '../../../../store/store';

interface IComponentProps extends IComponentBaseProps {
  listIndex?: number;
  onOpenFolder?: (index: number, id: number) => void;
  users?: IUsers;
}

interface IComponentState extends IComponentBaseState {
  activeLanguage: string;
}

class SearchTagView extends ItemView<IComponentProps, IComponentState> {
  constructor(props: IComponentProps) {
    super(props);

    this.state = {
      ...this.state,
      activeLanguage: getLangFromLocalStorage() as string,
    };
  }

  deleteItemTitle(name: string) {
    return i18n.t('deleteSearchTagTitle', {
      ns: 'documentManager',
      name: name,
    });
  }

  deleteItemMessage(name: string) {
    return i18n.t('deleteSearchTagMessage', {
      ns: 'documentManager',
      name: name,
    });
  }

  onOpenFunction(item: IProviderItemViewWithData) {
    return () => {
      const { listIndex } = this.props;
      this.props.onOpenFolder?.(listIndex! + 1, item.data.id);
    };
  }

  getThumbnail() {
    return ['folder-search.svg', orange];
  }

  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    this.props.dispatch(item_createNewSearchTag({ item: item.data }));
  }

  getBadgeView() {
    return (
      <li>
        {i18n.language !== 'fa' ? (
          <Icon type={'chevron-right'} />
        ) : (
          <Icon type={'chevron-left'} />
        )}
      </li>
    );
  }

  newItemPlaceHolder() {
    return i18n.t('smartFolderTitle', { ns: 'documentManager' });
  }

  newItemTitle() {
    return i18n.t('nameTitle', { ns: 'documentManager' });
  }

  getMenuActions(itemId: number, editable: boolean) {
    const menuActions = super.getMenuActions(itemId, editable);
    if (editable)
      menuActions.push({
        order: 0,
        callBack: () => {
          this.props.onOpenItem(this.props.item, 'edit');
        },
        message: i18n.t('configuration', { ns: 'documentManager' }),
        group: '1-actions',
      });
    return menuActions;
  }
}

export default SearchTagView;
